<iframe [src]="filePath" width="100%" height="100%" style="border: none"></iframe>
